import React from 'react';

function Footer() {
  return (
    <footer 
      className="py-3 mt-4"
      style={{
        backgroundColor: 'transparent',
        borderTop: '1px solid rgba(255, 255, 255, 0.05)'
      }}
    >
      <div className="container-fluid px-4">
        <div className="text-center">
          <small className="text-muted" style={{ fontSize: '0.8rem' }}>
            © {new Date().getFullYear()} LANturn • Remote Power & Kiosk Orchestrator
          </small>
          <div style={{ marginTop: '4px' }}>
            <small className="text-muted" style={{ fontSize: '0.78rem' }}>
              Developed by{' '}
              <a href="https://github.com/Stellar2703" target="_blank" rel="noopener noreferrer" style={{ color: '#60a5fa', textDecoration: 'none', fontWeight: 600 }}>
                Shashwath V R
              </a>
            </small>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
